module.exports = __webpack_public_path__ + "static/media/edit-orange-icon.1c6bfe21.svg";